<style lang="less">
  @import "./css/common.less";
</style>
<template>
  <div class="quality common-content">
    <navMenu></navMenu>
    <div class="content">
      <div class="banner-items">
        <img src="../assets/images/banner_Qualitycontrol.jpg">
        <div class="banner-title font-large">
          <span>QUALITY CONTROL</span>
        </div>
      </div>
      <div class="text-content">
        <div class="pc-items">
          <ContactBox></ContactBox>
        </div>
        <div class="article">
          <div class="bread-crumbs">
            <span class="pointer" @click="goToIndex">HOME></span>
            <span>QUALITY CONTROL</span>
          </div>
          <span class="article-title">QUALITY CONTROL</span>
          <div class="article-content">
            Lake Tai Apparel places significant emphasis on quality control. We have our own quality control team who examine virtually every garment and fabric. We also use independent laboratories to test for such things as resistance to pilling and abrasion, colour fastness, and fabric strength. Furthermore, we test for shrinkage, fabric weight, and colour consistency from lot to lot.
          </div>
        </div>
        <div class="mb-items">
          <ContactBox></ContactBox>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
import ContactBox from '../components/contactBox'
export default {
  data () {
    return {
    }
  },
  components: {
    NavMenu,
    Footer,
    ContactBox
  },
  methods: {
    goToIndex(){
      this.$router.push('/index')
    }
  },
  watch: {},
  mounted () {
    
  }
}
</script>
<style lang="less">
  .quality{
    
  }
</style>
